module.exports = __webpack_public_path__ + "img/Yuzde.d5e2432.png";